import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Drives the topbar bell: opens/closes the dropdown, subscribes to ActionCable
// to receive new notifications live, updates the badge count.
export default class extends Controller {
  static targets = ["badge", "dropdown", "list"]
  static values  = { userId: Number }

  connect() {
    this._open = false
    if (this.userIdValue > 0) {
      this._subscription = consumer.subscriptions.create(
        { channel: "NotificationsChannel", user_id: this.userIdValue },
        { received: (data) => this.onReceived(data) }
      )
    }
    document.addEventListener("click", this._onDocClick = (e) => {
      if (!this.element.contains(e.target) && this._open) this.close()
    })
  }

  disconnect() {
    this._subscription?.unsubscribe()
    document.removeEventListener("click", this._onDocClick)
  }

  toggle(event) {
    event.stopPropagation()
    this._open ? this.close() : this.open()
  }

  open()  { this._open = true;  this.element.classList.add("notif-bell--open") }
  close() { this._open = false; this.element.classList.remove("notif-bell--open") }

  onReceived(data) {
    this._bumpBadge(1)
    this._prepend(data)
  }

  _bumpBadge(delta) {
    if (!this.hasBadgeTarget) return
    const current = parseInt(this.badgeTarget.textContent, 10) || 0
    const next = Math.max(0, current + delta)
    this.badgeTarget.textContent = next > 99 ? "99+" : next
    this.badgeTarget.classList.toggle("notif-bell__badge--hidden", next === 0)
  }

  _prepend(data) {
    if (!this.hasListTarget) return
    const empty = this.listTarget.querySelector(".notif-bell__empty")
    if (empty) empty.remove()

    const item = document.createElement("a")
    item.className = "notif-bell__item notif-bell__item--unread"
    item.href = data.link || "#"
    item.innerHTML = `
      <div class="notif-bell__item-icon"><i class="${data.icon || "fa-solid fa-bell"}"></i></div>
      <div class="notif-bell__item-body">
        <div class="notif-bell__item-title">${this._escape(data.title)}</div>
        ${data.body ? `<div class="notif-bell__item-meta">${this._escape(data.body).slice(0, 80)}</div>` : ""}
        <div class="notif-bell__item-meta">à l'instant</div>
      </div>`
    this.listTarget.prepend(item)
  }

  _escape(s) {
    const div = document.createElement("div")
    div.textContent = String(s ?? "")
    return div.innerHTML
  }
}
